import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FilterMultiSelect } from "components/commons";
import { FilterBarContext } from "components/commons/filter-bar/filter-bar";
import lang from "translations";

// same pill/checkbox UI as the filter bar controls, but standing on its own
// inside the chart panel, so it brings its own open/close context
const GuestTypeFilter = ({ options = [], value = [], onChange }) => {
  const rootRef = useRef(null);
  const [activeFilter, setActiveFilter] = useState(null);

  const closeFilter = useCallback(() => setActiveFilter(null), []);
  const toggleFilter = useCallback(
    (filterId) => setActiveFilter((current) => (current === filterId ? null : filterId)),
    []
  );

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        closeFilter();
      }
    };
    document.addEventListener("pointerdown", handleDocumentClick, true);
    return () => document.removeEventListener("pointerdown", handleDocumentClick, true);
  }, [closeFilter]);

  const contextValue = useMemo(
    () => ({ activeFilter, closeFilter, toggleFilter }),
    [activeFilter, closeFilter, toggleFilter]
  );

  return (
    <div ref={rootRef}>
      <FilterBarContext.Provider value={contextValue}>
        <FilterMultiSelect
          id="guestTypes"
          align="right"
          label={lang.guests}
          allLabel={lang.bothGuestTypes}
          options={options}
          value={value}
          onChange={onChange}
        />
      </FilterBarContext.Provider>
    </div>
  );
};

export default GuestTypeFilter;
